// What could not be opened because its data is out of reach now (503
// `main_unreachable`: the Hub not reached) and was never read before: said
// briefly, and back where the person was. Before, the screen waited on with
// the back button shown, or said the server's words in its body (the person
// 2026-10-30).
//
// Promise: once per attempt (a second report within a moment is the same
// attempt), only for what a screen shows (a query someone watches) that has
// nothing to show, and a route that failed to load the same way.
import type { QueryClient } from "@tanstack/react-query";
import { m } from "@trameria/i18n";
import { ApiError } from "../data/api";
import { toast } from "../ui/toast";

const SAME_ATTEMPT_MS = 3000;
let last = 0;

export function isUnreachable(error: unknown): boolean {
  return error instanceof ApiError && error.code === "main_unreachable";
}

/** Says it cannot be opened and goes back (once per attempt). */
export function cannotOpen(back: () => void): void {
  const now = Date.now();
  if (now - last < SAME_ATTEMPT_MS) return;
  last = now;
  toast(m.shell_unreachable_cannot_open());
  back();
}

export function watchUnreachable(qc: QueryClient, back: () => void): void {
  qc.getQueryCache().subscribe((event) => {
    if (event.type !== "updated" || event.action.type !== "error") return;
    if (!isUnreachable(event.action.error)) return;
    const query = event.query;
    if (query.state.data !== undefined || query.getObserversCount() === 0)
      return;
    cannotOpen(back);
  });
}
